module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow@3-f8a9c47f80efd42f9d21cca6f3fbf85e.png";